import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme) => ({
  conditionalRow: {
    backgroundColor: '#ffcccc',
    '&:hover': {
      backgroundColor: '#fcb0b1 !important'
    }
  },
  titleContainer: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  title: {
    display: 'flex',
    alignItems: 'center'
  },
  form: {
    display: 'flex'
  },
  input: {
    flexGrow: 1
  },
  createButtonContainer: {
    marginLeft: '16px'
  }
}))

export default useStyles
